var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CheckboxGroup',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"input":_vm.updateValue}},_vm._l((_vm.field.values),function(fieldValue){return _c('Checkbox',{key:fieldValue.id,class:{ 'checkbox-required': fieldValue.required },attrs:{"label":fieldValue.value}},[_vm._v(" "+_vm._s(fieldValue.value)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }